import { z } from "zod";

export const SiteJoinRequestStatusSchema = z.enum([
  "PENDING",
  "APPROVED",
  "REJECTED",
  "CANCELLED",
]);

export const SiteJoinRequestSchema = z
  .object({
    id: z.string(),
    status: SiteJoinRequestStatusSchema,
    name: z.string(),
    companyName: z.string(),
    email: z.string().email(),
    phone: z.string().nullable().optional(),
    tradeRole: z.string().nullable().optional(),
    submittedAt: z.string().datetime(),
  })
  .strict();

export type SiteJoinRequest = z.infer<typeof SiteJoinRequestSchema>;
